// extracted by mini-css-extract-plugin
module.exports = {"basketItem__listItem":"BasketItem_basketItem__listItem__3yMU_","iconBox":"BasketItem_iconBox__wpeS-"};